import gql from "graphql-tag";

export default gql`query StatsPanel($date:Date!) {
    statsPanel(date:$date) 
  }`